var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page0"}},_vm._l((_vm.imageList),function(item,index){return _c('div',{key:index,staticClass:"home-page"},[_c('p',{staticClass:"home-png"},[_c('img',{attrs:{"src":item.src1}})]),_c('p',{staticClass:"home-png"},[_c('img',{attrs:{"src":item.src2}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }